module.exports = __webpack_public_path__ + "img/background.d15d4d53.png";